module.exports = __webpack_public_path__ + "media/images/common/img_recipe_order-76370d8c4e3d3eccceffeafe929c0866.png";